import React from 'react';
import { node } from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';

import Header from './header';
import Footer from './footer';
import HeadTag from './headTag';
import '../styles/common.module.scss';

const Layout = ({ children, title }) => (
  <StaticQuery
    query={graphql`
      query HeadingQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={ data => {
      return (
        <div style={{ minWidth: 1000, position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
          <HeadTag title={title || data.site.siteMetadata.title} />
          <Header />
          <div style={{ overflow: 'auto', position: 'absolute', top: 80, left: 0, right: 0, bottom: 0 }} id="box">
            {children}
            <Footer />
          </div>
        </div>
      )
    }}
  />
);

Layout.propTypes = {
  children: node.isRequired,
};

export default Layout;
